import { URL } from "../config";
import apiClient from "./BaseService";

const _getPayslipsForEmployee = async (companyId: string, year: string) =>
  apiClient.get(`${URL.GET_EMPLOYEE_PAYSLIPS}?company=${companyId}&year=${year}`);

export const PayslipsService = {
  _getPayslipsForEmployee,
};
